<template>
    <div id="app">
        <router-view/>
        <loader v-if="$store.getters.loading" />
    </div>
</template>

<script>
export default {
  components: {
    loader: () => import('@/components/Loader')
  }
}
</script>
